export default __webpack_public_path__ + "static/media/branding-logo.620aedb8.svg";